"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.measureLabel = exports.Measure = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
// eslint-disable-next-line no-shadow
var Measure;
(function (Measure) {
    Measure["PUNCTUALITY"] = "PUNCTUALITY";
    Measure["ONTIME"] = "COMPLETED";
    Measure["LATE"] = "COMPLETED_LATE";
    Measure["MISSED"] = "MISSED";
})(Measure = exports.Measure || (exports.Measure = {}));
exports.default = Measure;
function measureLabel(measure) {
    switch (measure) {
        case Measure.PUNCTUALITY:
            return lib_i18n_1.default.t('perf-measure-punctuality');
        case Measure.ONTIME:
            return lib_i18n_1.default.t('perf-measure-completed');
        case Measure.LATE:
            return lib_i18n_1.default.t('perf-measure-completed_late');
        case Measure.MISSED:
            return lib_i18n_1.default.t('perf-measure-missed');
    }
}
exports.measureLabel = measureLabel;
